import { actionTypes } from '../actions/links.action';
const initialState = {
    links: [],
    link: {
        'action_id' : null,
        'title' : '',
        'pixel' : '',
        'pixel_access_token' : '',
        'pixel_id' : null,
        'google_tag_id' : null,
        'afiliado_id' : null,
        'afiliado_percent': null
    },
    error: {}, 
    success: false
}

const LinksReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.links.data = state.links.data.concat(payload.links.data)
        }

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.links.data.findIndex(item => item.id === payload.id)
        state.links.data[index] = payload

        return {
            ...state,
            links: {
                ...state.links,
                data: [
                    ...[(index < 0) && payload],
                    ...state.links.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            links: {
                ...state.links,
                data: state.links.data.filter(item => item.id !== payload)
            }

        }

    case actionTypes.CHANGE:
        return {
            ...state,
            link: (payload === 'clear') ? {} : {
                ...state.link,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default LinksReducer